$(function() {

    var tooltips = $('.tooltip');

    tooltips.tooltipster && tooltips.tooltipster();
});
